import {createContext, useContext} from 'react';

import type {AfriexRoles} from '@/types';

export type AuthSessionUser = {
  firstName: string | null;
  email: string | null;
};

export type AuthContextType = {
  isAuthenticated: boolean;
  login: (irole: AfriexRoles, admin: AuthSessionUser) => void;
  logout: VoidFunction;
  role?: AfriexRoles;
  adminUser?: AuthSessionUser;
  authLoading?: boolean;
};

const defaultValue = {} as AuthContextType;

// The context object and its hook live in this JSX-free module so that
// AuthProvider.tsx only exports a component and keeps its Fast Refresh
// boundary. Consumers keep importing `useAuth` from '@/hooks/useAuth'.
export const AuthContext = createContext(defaultValue);

export const useAuth = () => useContext(AuthContext);
